import { List, Map as ImmutableMap, Record } from 'immutable';
import I18n from 'I18n';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';

// @ts-expect-error untyped import
import { Config } from '../config';
// @ts-expect-error untyped import
import { Metric } from '../config/metrics';
import * as ChartTypes from '../constants/chartTypes';
import * as ConfigTypes from '../constants/configTypes';
import { DEFAULT_FISCAL_YEAR_MONTH_NAME } from '../constants/dates';
import * as Frequency from '../constants/frequency';
import { SUM } from '../constants/metricTypes';
// @ts-expect-error untyped import
import { isSupportedCrmObject } from '../crmObjects/utils';
// @ts-expect-error untyped import
import makeDateRangeByType from '../lib/makeDateRangeByType';
import { dataTypeSettings } from '../retrieve/inboundDb/common/dataTypes';
import { CRM_VIEW_REPORT_CONTEXT } from './constants';
const customWidget = ImmutableMap({
  type: 'DATA_LAYER'
});
const dateFormat = 'YYYYMMDD';
const getDefaultFrequency = (dateRange, useFiscalYear = false, fiscalYearMonthName = DEFAULT_FISCAL_YEAR_MONTH_NAME) => {
  const {
    startDate,
    endDate
  } = makeDateRangeByType(dateRange, dateFormat, undefined, useFiscalYear, fiscalYearMonthName);
  const start = I18n.moment(startDate, dateFormat);
  const end = I18n.moment(endDate, dateFormat);
  const elapsedDays = end.diff(start, 'day');
  if (elapsedDays < 30) {
    return Frequency.DAY;
  } else if (elapsedDays < 90) {
    return Frequency.WEEK;
  }
  return Frequency.MONTH;
};
const PlatformReport = Record({
  id: null,
  name: 'CRM view report',
  displayParams: ImmutableMap(),
  chartType: '',
  config: Config({}),
  editors: null,
  portalId: null,
  createdAt: null,
  active: true,
  permissionSentence: null,
  insightParams: ImmutableMap(),
  chart: ImmutableMap(),
  reportContext: CRM_VIEW_REPORT_CONTEXT
}, 'PlatformReport');
export const getInboundDbReport = (dataType, viewName) => {
  var _dataTypeDefaults$dat, _dataTypeDefaults$dat2;
  const dataTypeDefaults = dataTypeSettings;
  const dateRange = {
    property: ((_dataTypeDefaults$dat = dataTypeDefaults[dataType]) === null || _dataTypeDefaults$dat === void 0 ? void 0 : _dataTypeDefaults$dat.defaultDateProperty) || 'hs_createdate',
    value: ImmutableMap({
      rangeType: 'THIS_QUARTER'
    })
  };
  const reportDataTypeKey = `reporting-data.dataTypes.${dataType}`;
  const reportName = viewName || (isValidI18nKey(reportDataTypeKey) ? I18n.text('reporting-data.createReport.defaultReportName', {
    dataType: I18n.text(`reporting-data.dataTypes.${dataType}`)
  }) : 'CRM view report');
  return PlatformReport({
    name: reportName,
    reportContext: CRM_VIEW_REPORT_CONTEXT,
    displayParams: ImmutableMap({
      customWidget,
      dataColumns: List(((_dataTypeDefaults$dat2 = dataTypeDefaults[dataType]) === null || _dataTypeDefaults$dat2 === void 0 ? void 0 : _dataTypeDefaults$dat2.defaultProperties) || []),
      showTotals: true
    }),
    chartType: ChartTypes.BAR,
    config: Config({
      configType: ConfigTypes.AGGREGATION,
      dataType: isSupportedCrmObject(dataType) ? 'CRM_OBJECT' : dataType,
      objectTypeId: isSupportedCrmObject(dataType) ? dataType : null,
      sort: List(),
      frequency: getDefaultFrequency(dateRange),
      filters: {
        dateRange
      }
    })
  });
};
export const getInboundDbReportWithMeasures = (dataType, viewName) => {
  var _dataTypeSettings$dat, _dataTypeSettings$dat2;
  const reportWithMetrics = getInboundDbReport(dataType, viewName).setIn(['config', 'metrics'], List([Metric({
    property: 'count',
    metricTypes: [SUM]
  })]));
  return (_dataTypeSettings$dat = dataTypeSettings[dataType]) !== null && _dataTypeSettings$dat !== void 0 && _dataTypeSettings$dat.defaultDimension ? reportWithMetrics.setIn(['config', 'dimensions'], List.of((_dataTypeSettings$dat2 = dataTypeSettings[dataType]) === null || _dataTypeSettings$dat2 === void 0 ? void 0 : _dataTypeSettings$dat2.defaultDimension)) : reportWithMetrics;
};
export const getInboundDbReportWithMeasuresAndProvidedDimension = (dataType, providedDimension, viewName) => {
  return getInboundDbReport(dataType, viewName).setIn(['config', 'metrics'], List([Metric({
    property: 'count',
    metricTypes: [SUM]
  })])).setIn(['config', 'dimensions'], List.of(providedDimension));
};